module.exports = __webpack_public_path__ + "static/media/29ADMSPC28.40d12702.jpg";